<template>
  <div>
    <PageView />
    <div class="range" v-if="txt">
      <section class="range_section">
        <div class="range_container">
          <div class="intro range_intro-car">
            <Car />
          </div>

          <div class="range_intro_batterie">
            <batteries
              :title="selectedModelElectricity == 1 ? distance1 : distance2"
            />
            <div class="container_batterie" v-if="windowWidth >= 980">
              <multi-button
                v-if="mobileToggle.nav[0].active"
                :title="txt.range.electricity.model.title"
                :list="txt.range.electricity.model.list"
                :lightBoxCopy="txt.range.electricity.model.tooltip"
                :active="selectedModelElectricity"
                dtmTitle="specification-model-electricity"
                v-on:event_parent="eventElectricity"
              />
              <div
                class="container_option d-none"
                v-if="
                  mobileToggle.nav[0].active && selectedModelElectricity == 1
                "
              >
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 1
                  "
                  :title="txt.range.electricity.model.e4orce.title"
                  :active="selectedE4force"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventeforce"
                />
                <!--
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 1
                  "
                  :title="txt.range.electricity.model.performance.title"
                  :active="SelectedPerformance"
                  :miniToggle="true"
                  :class="{ disable: selectedModelWheels == 1 }"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventPerformance"
                />
                -->
              </div>
              <div
                class="container_option"
                v-if="
                  mobileToggle.nav[0].active && selectedModelElectricity == 2
                "
              >
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 2
                  "
                  :title="txt.range.electricity.model.e4orce.title"
                  :active="selectedE4force"
                  :miniToggle="true"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventeforce"
                />
                <!--
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 2
                  "
                  :title="txt.range.electricity.model.performance.title"
                  :active="SelectedPerformance"
                  :miniToggle="true"
                  :class="{ disable: selectedModelWheels == 1 }"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventPerformance"
                />
                -->
              </div>
            </div>
          </div>
          <section class="separator"></section>
          <div class="range_center-panel">
            <Car />
          </div>
        </div>
        <!-- Mobile Toggle -->
        <div class="intro toggle_multi-choice">
          <p class="info_toogle_mobile">{{ txt.range.toogle.mobile_toogle }}</p>
          <toggle
            v-if="mobileToggle.nav"
            :list="mobileToggle.nav"
            :active="0"
            labelDTM="Passengers"
            v-on:event_parent="eventNav"
          />
        </div>
        <!-- End Mobile Toggle -->
        <transition name="fade" mode="out-in">
          <section class="range_control">
            <div class="range_left-panel">
              <multi-button
                v-if="mobileToggle.nav[0].active && windowWidth < 980"
                :title="txt.range.electricity.model.title"
                :list="txt.range.electricity.model.list"
                :lightBoxCopy="txt.range.electricity.model.tooltip"
                :active="selectedModelElectricity"
                dtmTitle="specification-model-electricity"
                v-on:event_parent="eventElectricity"
              />
              <div
                class="container_option d-none"
                v-if="
                  mobileToggle.nav[0].active && selectedModelElectricity == 1 && windowWidth < 980
                "
              >
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 1
                  "
                  :title="txt.range.electricity.model.e4orce.title"
                  :active="selectedE4force"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventeforce"
                />
                <!--
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 1
                  "
                  :title="txt.range.electricity.model.performance.title"
                  :active="SelectedPerformance"
                  :miniToggle="true"
                  :class="{ disable: selectedModelWheels == 1 }"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventPerformance"
                />
                -->
              </div>
              <div
                class="container_option"
                v-if="
                  mobileToggle.nav[0].active && selectedModelElectricity == 2
                  && windowWidth < 980
                "
              >
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 2
                  "
                  :title="txt.range.electricity.model.e4orce.title"
                  :active="selectedE4force"
                  :miniToggle="true"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventeforce"
                />
                <!--
                <toggle-switch
                  v-if="
                    mobileToggle.nav[0].active && selectedModelElectricity == 2
                  "
                  :title="txt.range.electricity.model.performance.title"
                  :active="SelectedPerformance"
                  :miniToggle="true"
                  :class="{ disable: selectedModelWheels == 1 }"
                  class="small-toggle"
                  svg="icon-check"
                  dtmTitle="specification-ecomode"
                  v-on:event_parent="eventPerformance"
                />
                -->
              </div>
              <multi-button
                v-if="mobileToggle.nav[0].active"
                :title="txt.range.wheels.title"
                :list="txt.range.wheels.list"
                :lightBoxCopy="txt.range.wheels.tooltip"
                :active="selectedModelWheels"
                dtmTitle="specification-wheels"
                v-on:event_parent="eventWheels"
              />
              <multi-button
                v-if="
                  txt.range.passengers.list &&
                  range.passengers &&
                  mobileToggle.nav[1].active
                "
                :title="txt.range.passengers.title"
                :list="txt.range.passengers.list"
                :lightBoxCopy="txt.range.passengers.tooltip"
                :active="range.passengers"
                dtmTitle="specification-passenger"
                v-on:event_parent="eventPassengers"
              />
              <scale-buttons
                v-if="txt.common.speed && mobileToggle.nav[3].active"
                :title="txt.common.speed.title"
                :active="Number(range.speed)"
                :lightBoxCopy="txt.common.speed.tooltip"
                :scale="this.speedScale"
                :range="txt.common.speed.range"
                :step="txt.common.speed.step"
                :SoM="txt.common.unitPerHour"
                v-on:event_parent="eventSpeed"
              />

              <toggle-switch
                v-if="txt.common.eco.title && mobileToggle.nav[0].active"
                :lightBoxCopy="txt.common.eco.tooltip"
                :title="txt.common.eco.title"
                :embed="txt.common.eco.tooltip.embed"
                :active="range.eco"
                class="ecoToggle"
                color="green"
                svg="icon-eco"
                dtmTitle="specification-ecomode"
                v-on:event_parent="eventEco"
              />
            </div>
            <div class="range_right-panel">
              <progress-circle
                v-if="
                  mobileToggle.nav[2].active && range.outside_temperature > -30
                "
                :title="txt.range.outside_temperature.title"
                :list="txt.range.outside_temperature.list"
                :step="5"
                :lightBoxCopy="txt.range.outside_temperature.tooltip"
                :active="range.outside_temperature"
                dtmTitle="specification-temperature"
                v-on:event_temperature="eventTemperature"
              />
              <div
                v-if="!txt.common.ac.tooltip.subtitle"
                :class="{ 'switch_container-column': setToColumn }"
                class="switch_container"
              >
                <toggle-switch
                  v-if="txt.range.heat.title && mobileToggle.nav[2].active"
                  :title="txt.range.heat.title"
                  :active="range.ac"
                  :is-enable="isHeatEnable"
                  color="brown"
                  svg="icon-Chauffage"
                  :disabled-a-c="disabledAC"
                  dtmTitle="specification-heater"
                  @event_parent="eventAc"
                />
                <heat-vs-ac-pop-up
                  v-if="txt.common.ac.title && mobileToggle.nav[2].active"
                  :lightBoxCopy="txt.range.acHeat.tooltip"
                />
                <toggle-switch
                  v-if="txt.common.ac.title && mobileToggle.nav[2].active"
                  :title="txt.common.ac.title"
                  :active="range.ac"
                  :is-enable="isAcEnable"
                  :disabled-a-c="disabledAC"
                  color="brown"
                  svg="icon-Fan_Clim"
                  dtmTitle="specification-ac"
                  @event_parent="eventAc"
                />
              </div>
              <div
                v-else
                :class="{ 'switch_container-column': setToColumn }"
                class="switch_container"
              >
                <toggle-switch
                  v-if="txt.common.ac.title && mobileToggle.nav[1].active"
                  :title="txt.common.ac.title"
                  :active="range.ac"
                  :is-enable="isAcEnable"
                  
                  color="blue"
                  svg="icon-Fan_Clim"
                  dtmTitle="specification-ac"
                  @event_parent="eventAc"
                />
              </div>
              <info
                v-if="mobileToggle.copy.wheels && mobileToggle.nav[0].active"
                :list="mobileToggle.copy.wheels"
              />
              <info
                v-if="mobileToggle.copy.passagers && mobileToggle.nav[1].active"
                :list="mobileToggle.copy.passagers"
              />
              <info
                v-if="
                  mobileToggle.copy.temperature && mobileToggle.nav[2].active
                "
                :list="mobileToggle.copy.temperature"
              />
              <info
                v-if="mobileToggle.copy.speed && mobileToggle.nav[3].active"
                :list="mobileToggle.copy.speed"
              />
            </div>
          </section>
        </transition>
        <section class="disclaimer-section">
          <fine-prints
            :disclaimer="txt.common.disclaimers.autonomy"
            :secondaryDisclaimer="txt.common.disclaimers.autonomy_secondary"
          />
        </section>
      </section>
    </div>
    <PageView
      v-if="dtm"
      pageName="vehicles|new|leaf|range-charging|estimatedautonomy"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import Navigation from "@/components/Navigation";
import Back from "@/components/shared/Buttons/Back";
import Batteries from "@/components/Autonomy/Batteries";
import Car from "@/components/Autonomy/Car";
import Toggle from "@/components/shared/Buttons/Toggle";
import Info from "@/components/shared/Buttons/Info";
import MultiButton from "@/components/shared/Buttons/MultiButton";
import ScaleButtons from "@/components/shared/Buttons/ScaleButtons";
import ToggleSwitch from "@/components/shared/Buttons/Switch";
import ProgressCircle from "@/components/shared/ProgressCircle";
import Lightbox from "@/components/shared/LightBox";
import finePrints from "@/components/finePrints";
import PageView from "@/components/shared/DTM/PageView";
import HeatVsAcPopUp from "@/components/Autonomy/HeatVsAcPopUp";

export default {
	name: "range",
	data() {
		return {
			windowWidth: 0,
			selectedModelElectricity: 1,
			selectedModelWheels: 1,
			selectedE4force: false,
			SelectedPerformance: false,
			distance1: null,
			distance2: null,
			disabledAC: false,
			allAutonomyDatas: {},
			selectedArray: {},
			mobileToggle: {
				// pass an array mobile toggle (Mobile UI is quite different than desktop)
				nav: [
					{
						title: "wheels",
						active: false,
						svg: "#icon-Wheels",
					},
					{
						title: "passagers",
						active: true,
						svg: "#icon-Profil",
					},
					{
						title: "temperature",
						active: false,
						svg: "#icon-Temperature",
					},
					{
						title: "speed",
						active: false,
						svg: "#icon-Vitesse",
					},
				],
				copy: {
					// pass an array of object to mobile the info toggle
					wheels: [],
					model: [],
					passagers: [],
					temperature: [],
					speed: [],
				},
			},
			speedScale: null,
			setToColumn: false,
			isAcEnable: true,
			isHeatEnable: false,
			isOptionsEnable: true,
		};
	},
	components: {
		Navigation,
		Back,
		Batteries,
		Car,
		Toggle,
		Info,
		MultiButton,
		ScaleButtons,
		ToggleSwitch,
		ProgressCircle,
		Lightbox,
		finePrints,
		PageView,
		HeatVsAcPopUp,
	},
	computed: {
		...mapState({
			txt: (state) => state.txt,
			passengers: (state) => state.range.passengers,
			country: (state) => state.country,
			range: (state) => state.range,
			dtm: (state) => state.dtm,
		}),
	},
	watch: {
		speedScale: function() {
			this.cleanSpeedRange();
		},

		range: {
			handler() {
				const temperature = this.range.outside_temperature;

				// les boutons toggle A/C et Heater sont toujours affichés

				// lorsque la température extérieure sélectionnée par l'utilisateur est >= 20°C :
				// - le bouton A/C est en état enabled
				// - le bouton Heater est en état disabled (et passe à Off automatiquement?)
				// - le bouton A/C permet d'activer la climatisation, dans ce cas l'autonomie baisse logiquement

				// lorsque la température extérieure sélectionnée par l'utilisateur est < 20°C :
				// - le bouton A/C est en état disabled (et passe à Off automatiquement?)
				// - le bouton Heater est en état enabled
				// - le bouton Heater permet d'activer le chauffage, dans ce cas l'autonomie baisse logiquement dans la même mesure que pour A/C == On


                if (temperature >= 25 || temperature <= 0) {
                    this.disabledAC = true;
                    
                } else {
                    this.disabledAC = false;
                }
				
				if (temperature >= 20) {
					this.isHeatEnable = false;
					return (this.isAcEnable = true);
                }
                if (temperature >= 25) {
                        return this.isAcEnable = true
                }
                
				this.isHeatEnable = true;
				return (this.isAcEnable = false);
			},
			deep: true,
		},

		windowWidth(newWidth) {
			if (newWidth <= 960) {
				return (this.mobileToggle.nav[0].active = true), (this.mobileToggle.nav[1].active = false), (this.mobileToggle.nav[2].active = false), (this.mobileToggle.nav[3].active = false);
			}
			return (this.mobileToggle.nav[0].active = true), (this.mobileToggle.nav[1].active = true), (this.mobileToggle.nav[2].active = true), (this.mobileToggle.nav[3].active = true);
		},
	},
	mounted() {
		this.windowWidth = window.innerWidth;
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.windowWidth = window.innerWidth;
			});
		});
		this.setCopyResponsiveInfo();
		this.getAllAutonomyDatas();
		this.cleanSpeedRange();
		this.checkLengthTitle();
	},

	methods: {
		async getAllAutonomyDatas() {
			const allDatas = await this.getEnvData();
			this.allAutonomyDatas = allDatas;

			if (allDatas) {
				return this.findCurrentValues();
			}
		},
		eventElectricity: function(val) {
			if (val === 1) {
				this.$store.commit("SET_MODEL", "64KWH");
				this.selectedE4force = false;
				this.SelectedPerformance = false;
				this.$store.commit("SET_E4FORCE", false);
				this.$store.commit("SET_PERFORMANCE", false);
			}
			this.$store.commit("SET_MODEL", "87KWH");
			this.selectedModelElectricity = val;
			this.findCurrentValues();
		},

		eventeforce: function() {
			this.selectedE4force = !this.selectedE4force;
			this.$store.commit("SET_E4FORCE", this.selectedE4force);
			if (this.selectedE4force === false) {
				this.$store.commit("SET_PERFORMANCE", false);
				this.SelectedPerformance = false;
			}
			this.findCurrentValues();
		},

		eventPerformance: function(val) {
			if (val === true) {
				this.selectedE4force = true;
				this.$store.commit("SET_E4FORCE", true);
			}
			this.$store.commit("SET_PERFORMANCE", val);
			this.SelectedPerformance = val;
			this.findCurrentValues();
		},

		async getEnvData() {
			if (process.env.VUE_APP_AXIOS === "local") {
				return require(`@/assets/data/vehicles/ariya/tools/range_calculator/countries/${this.country}/range_calculator_document.json`);
			}
			let txtdata = await axios.get(`/data/vehicles/ariya/tools/range_calculator/countries/${this.country}/range_calculator_document.json`);
			return txtdata.data;
		},

		setDefaultValues() {
			let object = null;
			object = this.allAutonomyDatas.filter((item) => item.default === true);
			return (this.selectedArray = object);
		},

		findCurrentRange() {
			this.selectedArray = this.allAutonomyDatas.filter((item) => {
				this.distance1 = this.selectedArray[0].battery_ranges[0].distance_range;
				this.distance2 = this.selectedArray[1] ? this.selectedArray[1].battery_ranges[0].distance_range : this.distance1;

				return item.passengers === this.range.passengers && item.speed === parseInt(this.range.speed) && item.outside_temperature == this.range.outside_temperature && item.ac === this.range.ac && item.eco === this.range.eco && item.e4force === this.range.e4force && item.performance === this.range.performance && item.wheel === this.range.wheel;
			});
		},

		findCurrentValues() {
			if (this.range.speed > 0) {
				this.findCurrentRange();
				this.distance1 = this.selectedArray[0].battery_ranges[0].distance_range;
				this.distance2 = this.selectedArray[1] ? this.selectedArray[1].battery_ranges[0].distance_range : this.distance1;
				return this.setSelectedRangeArray();
			}
			this.setDefaultValues();
			return this.setSelectedRangeArray();
		},

		setSelectedRangeArray() {
			this.$store.commit("SET_PASSENGERS", parseInt(this.selectedArray[0].passengers));
			this.$store.commit("SET_SPEED", this.selectedArray[0].speed);
			this.$store.commit("SET_TEMPERATURE", this.selectedArray[0].outside_temperature);
			this.$store.commit("SET_AC", this.selectedArray[0].ac);
			this.$store.commit("SET_ECO", this.selectedArray[0].eco);
			this.$store.commit("SET_PERFORMANCE", this.selectedArray[0].performance);
			this.$store.commit("SET_E4FORCE", this.selectedArray[0].e4force);
			this.$store.commit("SET_WHEEL", this.selectedArray[0].wheel);
			return this.$store.commit("SET_BATTERY_RANGE", this.selectedArray[0].battery_ranges[0]);
		},

		setCopyResponsiveInfo() {
			this.mobileToggle.copy.wheels[0] = this.txt.range.wheels.tooltip;
			this.mobileToggle.copy.wheels[1] = this.txt.common.eco.tooltip;
			this.mobileToggle.copy.passagers[0] = this.txt.range.passengers.tooltip;
			this.mobileToggle.copy.temperature[0] = this.txt.range.outside_temperature.tooltip;
			this.mobileToggle.copy.temperature[1] = this.txt.range.acHeat.tooltip;
			this.mobileToggle.copy.speed[0] = this.txt.common.speed.tooltip;
		},

		cleanSpeedRange() {
			this.speedScale = this.txt.common.speed.scale;
			this.speedScale.forEach((obj, index) => {
				if (!obj.data) {
					return this.$store.commit("REMOVE_SPEED_SCALE", index);
				}
			});
		},

		checkLengthTitle() {
			if (this.calculateLengthTitle(this.txt.common.ac.title) + this.calculateLengthTitle(this.txt.range.heat.title) >= 60) {
				return (this.setToColumn = true);
			}
		},
		calculateLengthTitle(str) {
			return str.length;
		},

		// START EVENTS
		// BEFORE YOU START TOUCHING THE EVENTS
		// For some technical reason I get back the index of the clicked button from the child components
		// This way it was easier for translated content, as it happened in city store to have some issue between configs/country because of the name of the battery
		// This way we get the index, then we compare it against the json of whatever country to know which option the user selected
		// Get the index of the selected Passagers
		eventPassengers: function(val) {
			this.$store.commit("SET_PASSENGERS", parseInt(val));
			this.findCurrentValues();
		},

		// Get the wheel
		eventWheels: function(val) {
			if (val === 1) {
				this.SelectedPerformance = false;
				this.$store.commit("SET_PERFORMANCE", false);
			}
			this.$store.commit("SET_WHEEL", val === 1 ? 19 : 20);
			this.selectedModelWheels = val;
			this.findCurrentValues();
		},

		// Get the index of the selected temperature
		eventTemperature: function(val) {
			
			if (val >= 30 ) {
				this.disabledAC = true;
			} 
            if (val >= 25 ) {
                this.$store.commit("SET_AC", true);
            }
            if (val <= 0) {
                this.$store.commit("SET_AC", true);
                this.isHeatEnable = true;
                this.isAcEnable = false
                this.disabledAC = true;
            }
            
			this.$store.commit("SET_TEMPERATURE", val);
			return this.allAutonomyDatas.length ? this.findCurrentValues() : "";
		},

		// Get the speed
		eventSpeed: function(val) {
			this.$store.commit("SET_SPEED", parseInt(val));
			this.findCurrentValues();
		},

		// Get the AC
		eventAc: function(val) {
			this.$store.commit("SET_AC", val);
			this.findCurrentValues();
		},

		// Get the eco
		eventEco: function(val) {
			this.$store.commit("SET_ECO", val);
			this.findCurrentValues();
		},

		// Mobile Toggle
		eventNav: function(index) {
			if (!this.mobileToggle.nav[index].active) {
				const findCurrentActive = this.mobileToggle.nav.findIndex((o) => o.active === true);
				this.mobileToggle.nav[findCurrentActive].active = false;
				return (this.mobileToggle.nav[index].active = true);
			}
		},
	},
};
</script>